<script setup lang="ts">
import ImgAuthority from './authority.svg?component';
import PillShapedSpan from 'theme/components/atoms/PillShapedSpan.vue';
import PartnerRakutenCvButton from '~/components/templates/_lp/PartnerRakutenTemplate/PartnerRakutenCvButton/PartnerRakutenCvButton.vue';

const now = new Date();
const isTargetAPeriod =
  new Date('2024-06-03T00:00:00+09:00') <= now &&
  now < new Date('2024-06-17T00:00:00+09:00');
const isTargetBPeriod = new Date('2024-06-17T00:00:00+09:00') <= now;
</script>

<template>
  <section>
    <div :class="$style.keyvisual">
      <div :class="$style.keyvisual__text">
        <p>
          <PillShapedSpan :class="$style.keyvisual__badge"
            >3分の家計診断を受けるだけ</PillShapedSpan
          >
        </p>
        <p
          v-if="isTargetAPeriod"
          :class="[
            $style.keyvisual__heading,
            $style['keyvisual__heading--20240603'],
          ]"
        >
          わたしと似た人の<br />貯蓄や年収はいくら？
        </p>
        <p
          v-else-if="isTargetBPeriod"
          :class="[
            $style.keyvisual__heading,
            $style['keyvisual__heading--20240617'],
          ]"
        >
          NISAだけで大丈夫？<br />みんなの投資額は？
        </p>
        <p v-else :class="$style.keyvisual__heading">
          NISA・資産運用を<br />無料でサポート
        </p>
        <PartnerRakutenCvButton :class="$style.keyvisual__button" />
      </div>
      <img src="./hero.png" :class="$style.keyvisual__img" />
    </div>
    <div :class="$style.footer">
      <ImgAuthority />
      <ul :class="$style.footer__footnote">
        <li>
          オカネコ for
          XXXXとは、「当社が提携している法人向けのオカネコサービスの総称」を指します。個別のサービス名称としては、XXXXに代わり、提携法人毎に提携法人名・サービス名が称されます。
        </li>
        <li>
          楽天証券認定IFAとは、提携金融商品取引業者に楽天証券が含まれる、金融商品仲介業者および金融サービス仲介業者を指します。
        </li>
        <li>
          ご案内できる金融商品はIFA事業者によって異なり、ご希望の商品のご案内ができない場合があります。詳細は各IFA事業者にご確認ください。
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" module>
.keyvisual {
  display: flex;
  justify-content: center;
  gap: 30px;
  padding: 40px 12px 0;
  flex-direction: column;
  align-items: center;
  background-color: $color-surface-accent-primary;
  color: $color-text-and-object-high-emphasis-inverse;

  @include desktop-only {
    align-items: flex-end;
    flex-direction: row;
  }

  &__text {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    @include desktop-only {
      display: block;
      text-align: start;
    }
  }
  &__img {
    width: 480px;
  }
  &__badge {
    font-size: 20px;
    font-weight: 600;
    padding: 8px 28px;
    background-color: $color-surface-primary;
    color: $color-text-and-object-accent-primary;
  }
  &__heading {
    margin-top: 4px;
    line-height: 60px;
    font-size: 40px;
    font-weight: 900;

    &--20240603 {
      line-height: 51px;
      font-size: 34px;
    }

    &--20240617 {
      line-height: 54px;
      font-size: 36px;
    }

    @include tablet-upper {
      font-size: 52px;
    }
  }
  &__button {
    margin-top: 12px;

    @include desktop-only {
      margin-bottom: 36px;
    }
  }
}

.footer {
  background-color: $color-surface-primary;
  color: $color-text-and-object-high-emphasis;
  padding: 32px 24px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @include desktop-only {
    flex-direction: row;
    justify-content: center;
  }

  &__numOfUser {
    font-size: 16px;
    font-weight: bold;
    &--accent {
      font-size: 32px;
      font-weight: 900;
    }
  }
  &__footnote {
    width: 100%;
    max-width: 520px;
    font-size: 10px;
    & > li::before {
      content: '※';
    }
  }
}
</style>
